import type { EvalOutputView } from '@app/shared';

type Picked = { choice: string | null };
type Sides = { first: EvalOutputView; second: EvalOutputView };

/** Index of the first item the owner has not chosen for yet; null when all are chosen. */
export function nextUnpicked(items: ReadonlyArray<Picked>): number | null {
  const i = items.findIndex((it) => it.choice === null);
  return i < 0 ? null : i;
}

export function progressOf(items: ReadonlyArray<Picked>): { picked: number; total: number } {
  return { picked: items.filter((it) => it.choice !== null).length, total: items.length };
}

/** Prompt version number by prompt id, from GET /admin/prompts; null while unknown. */
export function versionOf(
  list: { steps: ReadonlyArray<{ versions: ReadonlyArray<{ id: number; version: number }> }> } | undefined,
): (promptId: number) => number | null {
  const byId = new Map(list?.steps.flatMap((s) => s.versions.map((v) => [v.id, v.version] as const)) ?? []);
  return (id) => byId.get(id) ?? null;
}

/** While a run runs: the sides already written (an answer or an error) out of two per item. */
export function outputsSaved(detail: { items: ReadonlyArray<Sides> }): { saved: number; total: number } {
  const saved = detail.items.reduce(
    (n, it) => n + (it.first.kind !== 'pending' ? 1 : 0) + (it.second.kind !== 'pending' ? 1 : 0),
    0,
  );
  return { saved, total: detail.items.length * 2 };
}
